var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92426 1.07574C4.81174 0.963214 4.65913 0.9 4.5 0.9C4.34087 0.9 4.18826 0.963214 4.07574 1.07574C3.96321 1.18826 3.9 1.34087 3.9 1.5V1.9H3C2.44305 1.9 1.9089 2.12125 1.51508 2.51508C1.12125 2.9089 0.9 3.44305 0.9 4V15C0.9 15.557 1.12125 16.0911 1.51508 16.4849C1.9089 16.8788 2.44305 17.1 3 17.1H15C15.557 17.1 16.0911 16.8788 16.4849 16.4849C16.8788 16.0911 17.1 15.557 17.1 15V4C17.1 3.44305 16.8788 2.9089 16.4849 2.51508C16.0911 2.12125 15.557 1.9 15 1.9H14.1V1.5C14.1 1.34087 14.0368 1.18826 13.9243 1.07574C13.8117 0.963214 13.6591 0.9 13.5 0.9C13.3409 0.9 13.1883 0.963214 13.0757 1.07574C12.9632 1.18826 12.9 1.34087 12.9 1.5V1.9H5.1V1.5C5.1 1.34087 5.03679 1.18826 4.92426 1.07574ZM2.3636 3.3636C2.53239 3.19482 2.76131 3.1 3 3.1H15C15.2387 3.1 15.4676 3.19482 15.6364 3.3636C15.8052 3.53239 15.9 3.76131 15.9 4V4.9H2.1V4C2.1 3.76131 2.19482 3.53239 2.3636 3.3636ZM2.1 15V6.1H15.9V15C15.9 15.2387 15.8052 15.4676 15.6364 15.6364C15.4676 15.8052 15.2387 15.9 15 15.9H3C2.76131 15.9 2.53239 15.8052 2.3636 15.6364C2.19482 15.4676 2.1 15.2387 2.1 15Z",
    fill: "white",
    stroke: "#407DBB",
    strokeWidth: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fec56f7deb323e41ba4356dd7ea1fe91.svg";
export { ForwardRef as ReactComponent };